import React from 'react';

const RepeatIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0433 7.13135C18.2564 7.91242 18.9998 9.27929 18.9998 10.7243V10.7243C18.9998 13.1065 17.0825 15.0202 14.6955 15.0202H5.3042"
      stroke="#555B67"
      strokeWidth="2"
    />
    <path
      d="M2.95652 12.5206C1.74348 11.7396 1 10.3727 1 8.92772V8.92772C1 6.54546 2.91739 4.63184 5.30435 4.63184H14.6957"
      stroke="#555B67"
      strokeWidth="2"
    />
    <path
      d="M11.9565 8.26395L15.5957 4.63197L11.9565 1"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8.04343 18.6521L4.4043 15.0202L8.04343 11.3882"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default RepeatIcon;
